import { useGonePageCommon } from "./gone-page-common";
import classNames from "classnames";
import style from "@/pages-react/gone-page/gone-page.module.scss";
import gonePageSvg from "@/assets/gone-page/gone-page.svg";
import { useTranslation } from "react-i18next";

export const GonePageDesktop = (props: { mpn: string }) => {
  const { renderForm } = useGonePageCommon(props.mpn);

  const { t } = useTranslation();

  return (
    <div className={classNames(style.container, style.desktop)}>
      <div className={style.titles}>
        <div className={style.title}>
          {props.mpn} {t("A3584E94A0A6B76E.no-longer-available", "is no longer available")}
        </div>
        <div className={style.subtitle}>{t("9EDC5446096352CA.but-we-found", "But we found a way to assist you")}</div>
      </div>
      <div className={style.content}>
        <div>
          <img src={gonePageSvg} alt="Gone page" className={style.image} />
        </div>
        <div className={style.formWrapper}>
          <div className={style.arrowLeft}></div>
          {renderForm()}
        </div>
      </div>
    </div>
  );
};
